import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { IBulkReplaceLocationGroup } from 'src/features/components/bulkReplaceComponentPage/BulkReplaceComponentPage.interface';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetScheduleListWithPagination = (filters: string[] = []) => {
  return useQuery({
    queryKey: queryKeys.scheduleList.pagination(filters),
    queryFn: () => fetchScheduleList(filters),
    keepPreviousData: true,
    staleTime: Infinity,
  });
};

export const fetchScheduleList = async (filters: string[] = []) => {
  const response = await requestCCApi({
    url: `/scheduleList${generateQuery([], concat(filters))}`,
  });

  return response as {
    data: IBulkReplaceLocationGroup[];
    totalPages: number;
    totalCount: number;
  };
};
